import AnyMap from "./AnyMap.mts";

namespace UWeakMap {
  export type Any = WeakMap<any, any>;
  export type Key<M extends Any> =
    M extends WeakMap<infer Key, any> ? Key : never;
  export type Value<M extends Any> =
    M extends WeakMap<any, infer Value> ? Value : never;

  export const getOr = AnyMap.getOr;
}

export default UWeakMap;
